export default "/_next/static/images/9659767262135846a027c24c16b2938b.png";